import React, { memo } from 'react';
import styles from './dialogRightTag.module.scss';

const DialogRightTag = ({ children }) =>
    <div className={styles.dialogRightTag}>
        {children}
    </div>

export default memo(DialogRightTag);